<template>
  <div>Button</div>
</template>

<script>
export default {
  name: "MoButton",
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/plugin/Button.vue